import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  @service store!: DS.Store;

  async model() {
    await this.store.queryRecord('account-usage', {});

    // In Ember 4.12, when transitioning away from the "workspaces/new" route,
    // it's possible that the new environment record isn't saved - but also not
    // unloaded from the store yet in the "deactivate" route hook.
    //
    // In which case "this.store.peekAll('environment')" would return it here, and
    // so try to render an unsaved environment in the workspaces table - causing
    // errors due to empty "id" property.
    //
    // Tests demonstrating the problem: http://127.0.0.1:4200/tests?testId=a75810bd&testId=9d9cce76
    //
    // To fix it, let's filter out the new environment:
    return this.store.peekAll('environment').filter((e) => !e.get('isNew'));
  }
}
